const startAnimationOnSteps = (manual: HTMLOListElement) => {
  const steps = manual.querySelectorAll<HTMLLIElement>('li')
  const delay = 100

  steps.forEach((step, index) => {
    setTimeout(() => {
      step.classList.add('is-visible')
    }, index * delay)
  })
}

const resetAnimationOnSteps = (manual: HTMLOListElement) => {
  const steps = manual.querySelectorAll<HTMLLIElement>('li')
  steps.forEach((step) => {
    step.classList.remove('is-visible')
  })
}

const handleProductSwitching = () => {
  const orderManualSwitcher = document.querySelector<HTMLFieldSetElement>('[data-product-switcher]')
  const radioButtons = orderManualSwitcher?.querySelectorAll<HTMLInputElement>('input[name="card-order-products"]')
  const orderManuals = document.querySelectorAll<HTMLOListElement>('[data-app-order]')

  if (!orderManualSwitcher || !radioButtons || orderManuals.length === 0) {
    console.error('Order manual switcher or radio buttons or manuals not found')
    return
  }

  radioButtons.forEach((radio) => {
    radio.addEventListener('change', (event) => {
      orderManuals.forEach((manual) => {
        manual.setAttribute('hidden', 'true')
        resetAnimationOnSteps(manual)
      })

      const targetManualId = (event.target as HTMLInputElement).value
      const targetManual = document.querySelector<HTMLOListElement>(`#${targetManualId}`)

      if (targetManual) {
        targetManual.removeAttribute('hidden')
        startAnimationOnSteps(targetManual)
      }
    })
  })
}

const setObserverForManual = (manual: HTMLOListElement) => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          startAnimationOnSteps(manual)
          observer.unobserve(manual)
        }
      })
    },
    {
      threshold: 0.2,
    },
  )

  observer.observe(manual)
}

export const initCardOrderSection = () => {
  const orderManuals = document.querySelectorAll<HTMLOListElement>('.card-order__product-card-order')
  orderManuals.forEach((manual) => {
    setObserverForManual(manual)
  })
  handleProductSwitching()
}
